import { ReactNode, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { createTopLayerHost, hideTopLayerHost } from '@ardoq/dom-utils';

const TAG_NAME = 'drawer-container';

let portalChildrenCount = 0;

const getPortalTarget = (): HTMLElement => {
  const existingTarget = document.querySelector<HTMLElement>(TAG_NAME);
  if (existingTarget) return existingTarget;

  return createTopLayerHost(TAG_NAME);
};

const canShowPopover = (target: HTMLElement): boolean =>
  typeof target.showPopover === 'function';

export const DrawerPortal = ({ children }: { children: ReactNode }) => {
  const targetRef = useRef<HTMLElement>(getPortalTarget());

  useEffect(() => {
    const target = targetRef.current;
    portalChildrenCount++;
    const container = document.fullscreenElement ?? document.body;
    container.appendChild(target);
    if (canShowPopover(target) && !target.matches(':popover-open')) {
      target.showPopover();
    }

    return () => {
      portalChildrenCount--;
      if (portalChildrenCount > 0) return;
      if (canShowPopover(target)) {
        hideTopLayerHost(target);
      }
      target.remove();
    };
  }, []);

  return createPortal(children, targetRef.current);
};
